import React, { Fragment, useState } from 'react';
import {
  Button,
  useUnselectAll,
  useNotify,
  showNotification,
  refreshView
} from 'react-admin';
import { connect } from 'react-redux';
import FundFamilyApi from '../../../core/apis/FundFamilyApi';
import Confirm from '../../../core/components/forked/layout/Confirm';
import { getIcError } from '../../../core/providers/utils';

const RemoveButton = props => {
  const [open, setOpen] = useState(false);

  const handleClick = () => setOpen(true);
  const handleDialogClose = () => setOpen(false);

  const notify = useNotify();
  const unselectAll = useUnselectAll();

  const handleConfirm = async () => {
    try {
      let count = await props.updateMany(props);
      notify('ra.notification.deleted', {
        messageArgs: { smart_count: count }
      });

      unselectAll('funds');
    } catch (error) {
      notify('Error: Items was not deleted', { type: 'error' });
    }
    setOpen(false);
  };

  return (
    <Fragment>
      <Button label="Remove" onClick={handleClick} />
      <Confirm
        isOpen={open}
        title="Remove Funds from Fund Family"
        content="Are you sure you want to delete selected funds from Fund Family?"
        onConfirm={handleConfirm}
        onClose={handleDialogClose}
        confirm="ra.action.delete"
      />
    </Fragment>
  );
};

class RemoveFundFamilyFundButton extends React.Component {
  updateMany = async props => {
    const { refreshView, selectedIds, funds, fundFamilyId } = props;
    const fundIdsToUnlink = [];

    if (
      selectedIds &&
      selectedIds.length > 0 &&
      funds &&
      funds.data &&
      Object.keys(funds.data).length > 0
    ) {
      selectedIds.forEach(fundId => {
        let visibleFunds = funds.data;
        let initialFund = Object.keys(visibleFunds).find(el => el === fundId);
        if (initialFund && visibleFunds[initialFund]) {
          const fund = visibleFunds[initialFund];
          if (fund.fundFamilyId) {
            fundIdsToUnlink.push(fund.id);
          }
        }
      });
    }

    if (fundIdsToUnlink.length > 0) {
      FundFamilyApi.unlinkFundsFromFundFamily(fundFamilyId, fundIdsToUnlink)
        .then(() => {
          refreshView();
        })
        .catch(error => {
          showNotification('ra.notification.server', 'error', {
            messageArgs: { message: getIcError(error) }
          });
        });
    }
    return fundIdsToUnlink.length;
  };

  render() {
    return <RemoveButton {...this.props} updateMany={this.updateMany} />;
  }
}

const mapDispatchToProps = {
  refreshView
};

export default connect(null, mapDispatchToProps)(RemoveFundFamilyFundButton);
